<template>
  <div class="menuLeft">
    <el-row class="tac">
      <el-col :span="24">
        <el-menu
          :default-active="numberIndex.toString()"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose">
          <el-menu-item :index='item.msgType.toString()' v-for="(item,index) in list" :key='index' v-if="item.msgType!=4">
            <div @click="msgList(item.msgType,item)">
              <!-- <i class="el-icon-location"></i> -->
              <div class="bgIcon">
                <el-badge :is-dot="item.haveNew"  class="item">
                  <img src="static/image/msg/baodan_icon_notice@2x.png" v-if="item.msgType==0">
                  <img src="static/image/msg/xitong_icon_notice@2x.png" v-if="item.msgType==1">
                  <img src="static/image/msg/kehu_icon_notice@2x.png" v-if="item.msgType==2">
                  <img src="static/image/msg/kehu_icon_notice@2x.png" v-if="item.msgType==4">
                  <img src="static/image/msg/richeng_icon_notice@2x.png" v-if="item.msgType==3">
                  <img src="static/image/msg/richeng_icon_notice@2x.png" v-if="item.msgType==5">
                </el-badge>
                <!-- <div class="dot" v-show="true"></div> -->
              </div>
              <div class="msgTitle">
                 <div class="msgSub">{{item.msgTypeName}}<span class="sendtime">{{item.recentMessage.sendTime}}</span></div>
                 <div class="intro">{{item.recentMessage.title}}</div>
              </div>
              <!-- <span slot="title">保单消息</span> -->
            </div>
          </el-menu-item>
        </el-menu>
      </el-col>
</el-row>
  </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
// 导入n3导航插件
export default {
  //        引入相关模板
  name: 'MsgSidebar',
  //        初始化定义变量
  data () {
    return {
      list:[],
      numberIndex:'0',
      dot:false,
    }
  },
  /*
     * 在模板渲染成html后调用，
     * 通常是初始化页面完成后，
     * 再对html的dom节点进行一些需要的操作。
     * */
  mounted () {
    // let that = this
    this.numberIndex = this.$route.query.msgType
    // alert(this.numberIndex)
    // switch(this.$route.query.msgType){
    //   case '0':
    //   this.numberIndex = '0'
    //   break
    //   case '1':
    //   this.numberIndex = '1'
    //   break
    //   case '2':
    //   this.numberIndex = '2'
    //   break
    //   case '3':
    //   this.numberIndex = '3'
    //   break
    //   default :
    //   this.numberIndex = '0'
    //   break      
    // }  
    // alert(this.numberIndex)  
    this.getAllType()
  },
  // 方法集
  methods: {
    handleOpen (key, keyPath) {
      // key:当前点击菜单index
      // keyPath: 当前点击菜单及其父菜单的级联index
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    },
    msgList(type,item){
      let that=this
      // that.tabAllRead(type)
      that.numberIndex = type
      if(item.haveNew){
        api.post(that.$url.tabAllRead,{msgType:type},(res)=>{
          if(res.result.isSuccess){
            that.$router.push({name:'msgList',query:{msgType: item.msgType}})
            item.haveNew=false
          }
        })
      }else{
        that.$router.push({name:'msgList',query:{msgType: item.msgType}})
      }
    },
     // 时间转字符串
    changetime (data) {
      let getDate = new Date(data)
      let y = getDate.getFullYear()
      let M = getDate.getMonth() + 1
      let d = getDate.getDate()
      let format = y + '-' + M + '-' + d
      return format
    },
    getAllType() {
      let that = this;
      api.post(that.$url.getAllType, {}, res => {
        console.log(res);
        if (res.result.isSuccess === true) {
          this.list=res.data.typeMessages

        }
      });
    },
  },
  //        实时监控路由改变就执行
  watch: {
    $route: {
            handler: function(val, oldVal){
              // alert(JSON.stringify(val))
              let that = this
              // console.log(val.query.msgType,'监听==')
              that.numberIndex = val.query.msgType           
            },
            // 深度观察监听
            deep: true,
            immediate: true
            }
  
  }
}
</script>

<style scoped>
.menuLeft{
  width:100%;
  float: left;
  height: 100%;
  background: #EEEEEF;
  /* -webkit-box-shadow: 3px 0px 5px 0px rgba(162,187,225,0.3);
  box-shadow: 3px 0px 5px 0px rgba(162,187,225,0.3) */
}
.el-menu{
  border: 0;
  background: transparent;
  
}
.el-menu-item{
  border-bottom: 1px solid #E5E5E5;
  height: 70px;
  line-height: 70px;
  color: #000011;
}
.el-menu-item:focus, .el-menu-item:hover {
    outline: 0;
    background-color: #fff;
    color: #3D62AD;
}
.el-menu-item:focus{
  background-color: #EEEEEF;
  color: #000011;  
}

/* .el-menu-item:focus, .el-menu-item:hover i{
  color: #3D62AD;
} */
.el-menu-item.is-active {
    background-color: #fff;
    color: #3D62AD;
    /* color: #999; */
}
/* .el-menu-item.active {
    background-color: #5B9FEC;
    color: #fff;
} */


.bgIcon{
  display: inline-block;
  width: 40px;
  height: 40px;
  position: relative;
  /* background:url("/static/msg/baodan_icon_notice@2x.png") no-repeat center;
  background-size:100%; */
}
.bgIcon img{
  width:100%;
}
.el-badge{
  width: 40px;
  height: 40px;
  line-height: 40px;
  display: block;
}
.bgIcon >>> .el-badge__content{
  border:0;
}
.bgIcon >>> .el-badge__content, .el-progress.is-exception .el-progress-bar__inner{
  background-color: #f00;
}
/* .bgIcon .dot{
  display: block; 
  width: 8px; 
  height: 8px; 
  border-radius:50%; 
  background:red; 
  position: absolute; 
  top:0px; 
  right:0;
} */
.msgTitle{
  display: inline-block;
  line-height: 26px;
  padding-left: 10px;
}
.msgSub{
  font-size: 18px;
  font-weight: 600;
  position: relative;
  /* -webkit-font-smoothing: subpixel-antialiased; */
}
.sendtime{
  position:absolute;
  right: 0px;
  top: 0;
  font-weight: normal;
  font-size: 13px;
  color: #919191;
}
.intro{
  width: 195px;
  font-size: 14px;
  color:#919191;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap
}

   /* @media screen and (max-width: 1024px) {
    .menu{
      font-size: 14px;
    }
    .title-detail{
      font-size:12px;
    }
  }
  @media screen and (min-width: 1400px) {
    .menu-item {
      padding: 15px 0;
    }
    .menu{
      width:8%;
    }
  }
  @media screen(min-width: 1024px) and (max-width: 1400px) {
    .menu-item {
      padding: 15px 0;
    }
  } */
</style>



// WEBPACK FOOTER //
// src/layout/MsgSidebar.vue